import { Text } from '@insight-health-ai/roseate/components';
import classNames from 'classnames';
import type { FormField } from '../types';

type WrapperProps = {
  field: FormField;
  error?: string;
  children: React.ReactNode;
};

export function Wrapper({ field, error, children }: WrapperProps) {
  if (field.type === 'checkbox') {
    return (
      <div>
        {children}
        {field.description && (
          <Text appearance="secondary" className="mt-1 text-sm">
            {field.description}
          </Text>
        )}
        {error && (
          <Text appearance="danger" className="mt-1 text-sm">
            {error}
          </Text>
        )}
      </div>
    );
  }

  return (
    <div className="flex flex-col gap-1.5">
      <label
        className={classNames(
          'text-base font-medium',
          field.disabled ? 'text-gray-400' : 'text-gray-700',
          field.labelClassName
        )}
      >
        {field.label}
        {field.required && !field.disabled && (
          <span className="text-red-500 ml-0.5">*</span>
        )}
      </label>
      {field.description && (
        <Text appearance="secondary">{field.description}</Text>
      )}
      {children}
      {error && (
        <Text appearance="danger" className="mt-1 text-sm">
          {error}
        </Text>
      )}
    </div>
  );
}
